/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a nucleotide sequence (A, C, G, T/U) to calculate its molecular weight.`)
};

const es_dnamw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce una secuencia de nucleótidos (A, C, G, T/U) para calcular su peso molecular.`)
};

const de_dnamw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine Nukleotidsequenz (A, C, G, T/U) ein, um ihr Molekulargewicht zu berechnen.`)
};

const nl_dnamw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul een nucleotidesequentie in (A, C, G, T/U) om het molecuulgewicht te berekenen.`)
};

const fr_dnamw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez une séquence nucléotidique (A, C, G, T/U) pour calculer sa masse moléculaire.`)
};

const it_dnamw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci una sequenza nucleotidica (A, C, G, T/U) per calcolarne il peso molecolare.`)
};

const pt_br2_dnamw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe uma sequência de nucleotídeos (A, C, G, T/U) para calcular seu peso molecular.`)
};

const pt_dnamw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza uma sequência de nucleótidos (A, C, G, T/U) para calcular a sua massa molecular.`)
};

const ja_dnamw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヌクレオチド配列（A, C, G, T/U）を入力すると分子量が計算されます。`)
};

const zh_dnamw_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入核苷酸序列（A、C、G、T/U）以计算其分子量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_hint_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_hint_empty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_hint_empty", locale)
	if (locale === "en") return en_dnamw_hint_empty(inputs)
	if (locale === "es") return es_dnamw_hint_empty(inputs)
	if (locale === "de") return de_dnamw_hint_empty(inputs)
	if (locale === "nl") return nl_dnamw_hint_empty(inputs)
	if (locale === "fr") return fr_dnamw_hint_empty(inputs)
	if (locale === "it") return it_dnamw_hint_empty(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_hint_empty(inputs)
	if (locale === "pt") return pt_dnamw_hint_empty(inputs)
	if (locale === "ja") return ja_dnamw_hint_empty(inputs)
	return zh_dnamw_hint_empty(inputs)
};